import script from "./RoundDiagram.vue?vue&type=script&setup=true&lang=js"
export * from "./RoundDiagram.vue?vue&type=script&setup=true&lang=js"

import "./RoundDiagram.vue?vue&type=style&index=0&id=3c8d0888&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c8d0888"]])

export default __exports__